<script>
  import Goal from "../Components/Goals/Goal.svelte";
  import GoalOptions from "./GoalOptions.svelte";
  import { clickForGoalSettings } from "../static";
  import { ignore } from "../../Common/tools";
  import {External, M} from "../../external";

  export let data,
    onChange = ignore,
    extraGoals = [];
  let cmps = [];
  let counter = 0;

  export function get() {
    return data;
  }

  const onUpdate = (goal) => {
    let index = 0;
    let count = 0;
    for (let count = 0; count < data.length; count++) {
      if (data[count].id === goal.id) {
        index = count;
      }
    }
    data[index].name = goal.name;
    data[index].type = goal.type;
    data[index].settings = goal.settings;
    onChange();
  };

  const onClick = (goal) => {
    if (goal && goal.type) {
      clickForGoalSettings(goal.type, goal, onUpdate);
    } else {
      let component;

      External.Tools.showWindow({
        title: M.CHOOSE_A_GOAL,
        icon: External.Popup.ICON_EDIT,
        width: 500,
        customClass: "add-member-dialog",
        isModal: false,
        withDarkBackground: true,
        forceAtRight: External.showBuilderPopupsOnFullHeight,
        markup: '<div class="popup-widget-wrapper bind-component"></div>',
        action: {
          onShow: function (popup, ui) {
            component = new GoalOptions({
              target: ui.find(".bind-component")[0],
              props: {
                extraGoals: extraGoals,
                add: (goal) => {
                  popup.close();
                  onAdd(goal);
                }
              }
            });
          },
          onHide: function () {
            if (component) {
              component.$destroy();
              component = null;
            }
          }
        }
      });
    }
  };

  const onAdd = (newGoal) => {
    counter = 0;
    if (data && data.length) {
      counter =
        Math.max.apply(
          Math,
          data.map(function (trig) {
            return trig.id;
          })
        ) + 1;
    }

    data = [
      ...data,
      {
        id: counter,
        name: newGoal.name,
        type: newGoal.type,
        settings: newGoal.settings
      }
    ];

    onChange();
  };

  const onRemove = (index) => {
    External.Tools.prompt(M.DELETE, M.DELETE_GOAL_QST, function () {
      data = [...data.slice(0, index), ...data.slice(index + 1, data.length)];

      onChange();
    });
  };
  $: cmps = cmps.filter((el) => el);
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-25 mb-10 t-center h4-bigger">{M.GOAL_TITLE}</h4>
  <span class="light-gray-text t-center col20 f-left mb-15">{M.GOAL_TITLE_DESC}</span>
  <ul>
    {#each data as goal, index (goal.id)}
      <Goal bind:this={cmps[index]} bind:data={goal} onClick={() => onClick(goal)} onRemove={() => onRemove(index)} />
    {/each}
  </ul>
  <div class="col20 f-left mt-15 t-center">
    <a on:click={() => onClick(null)} class="middle-button with-icon blue f-none inline-block">{M.ADD_NEW_GOAL}</a>
  </div>
</div>
